import phoneify from 'phoneify';

export default function formatPhone(phone) {
  try {
    return performFormatting(stripDigits(phone));
  } catch (err) {
    console.warn(`Error formatting phone number ${phone}: ${err.message}`);
  }
  return '';
}

function stripDigits(input) {
  return (input && input.replace) ? input.replace(/\D/g, '') : input;
}

function performFormatting(strippedPhone) {

  if (!strippedPhone) {
    return '';
  }

  const phoneified = phoneify(strippedPhone);
  if (!phoneified) {
    throw new Error('Phoneify returned null (see log msg)');
  }

  return phoneified.countryCodeRemoved ? phoneified.countryCodeRemoved.addTrailingSlashes : '';
}



// WEBPACK FOOTER //
// ./shared/lib/prettyPhone.js